import React from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { useGetOldGamesFeeds } from 'js/components/system/App/hooks';
import { Search } from './Search';
import style from './StickySearch.scss';

export const StickySearch = () => {
    useGetOldGamesFeeds();
    const oldGamesFeeds = useAppSelector(prop(['oldGamesFeeds']));
    const isEmptyFeedObject = Object.keys(oldGamesFeeds).length === 0;

    return !isEmptyFeedObject
        ? (
            <div className={`${style.container} cms-sticky-search`} id={'sticky_search'}>
                <div className={style.content}>
                    <div className={style.searchContainer}>
                        <div className={style.search}>
                            <Search key={1} className={style.searchComponent} />
                        </div>
                    </div>
                    <div className={style.chatContainer}>
                        <div className={style.chat} id={'swiss_chat'}></div>
                    </div>
                </div>
            </div>
        )
        : null;
};
